import React from 'react';

export const FoundersSection = () => {
  return (
    <section
      style={{
        backgroundColor: '#ffffff',
        padding: '100px 24px',
        position: 'relative'
      }}
    >
      <div
        style={{
          maxWidth: '800px',
          margin: '0 auto',
          textAlign: 'center'
        }}
      >
        {/* Headline */}
        <h2
          style={{
            fontFamily: '"Source Serif Pro", Georgia, serif',
            fontSize: 'clamp(32px, 5vw, 48px)',
            fontWeight: '600',
            color: '#111111',
            lineHeight: '1.2',
            margin: '0 0 48px'
          }}
        >
          Real Patients™ was founded by, well—
          <span style={{ position: 'relative', display: 'inline' }}>
            <span
              style={{
                position: 'absolute',
                left: '-2%',
                right: '-2%',
                bottom: '5%',
                height: '35%',
                background: 'linear-gradient(90deg, rgba(250, 190, 192, 0.5) 0%, rgba(247, 192, 138, 0.4) 100%)',
                zIndex: 0,
                borderRadius: '3px'
              }}
            />
            <span style={{ position: 'relative', zIndex: 1 }}>real patients</span>
          </span>.
        </h2>

        {/* Body copy */}
        <div
          style={{
            fontSize: '18px',
            color: '#4A4A4A',
            lineHeight: '1.8',
            textAlign: 'left',
            maxWidth: '700px',
            margin: '0 auto'
          }}
        >
          <p style={{ margin: '0 0 24px' }}>
            Co-founders Jen and Ronnie grew up navigating chronic illness themselves. Along the way, they saw how often patient experiences were misunderstood, simplified, or overlooked—especially when new products, medicines, and services were being developed.
          </p>
          <p style={{ margin: '0 0 24px' }}>
            They built Real Patients™ to make it easier for healthcare innovators to truly understand life from the patient perspective—
            <span style={{ position: 'relative', display: 'inline-block' }}>
              <span
                style={{
                  position: 'absolute',
                  left: '-2%',
                  right: '-2%',
                  bottom: '5%',
                  height: '35%',
                  background: 'linear-gradient(90deg, rgba(235, 160, 155, 0.7) 0%, rgba(245, 185, 165, 0.65) 40%, rgba(250, 200, 160, 0.6) 70%, rgba(245, 215, 170, 0.5) 100%)',
                  transform: 'skewX(-1deg)',
                  zIndex: 0,
                  borderRadius: '2px'
                }}
              />
              <span style={{ position: 'relative', zIndex: 1 }}>before</span>
            </span>
            {' '}decisions are made.
          </p>
          <p style={{ margin: '0' }}>
            Over the past decade, Real Patients™ has grown into a{' '}
            <span style={{ position: 'relative', display: 'inline-block' }}>
              <span
                style={{
                  position: 'absolute',
                  left: '-2%',
                  right: '-2%',
                  bottom: '5%',
                  height: '35%',
                  background: 'linear-gradient(90deg, rgba(235, 160, 155, 0.7) 0%, rgba(245, 185, 165, 0.65) 40%, rgba(250, 200, 160, 0.6) 70%, rgba(245, 215, 170, 0.5) 100%)',
                  transform: 'skewX(-1deg)',
                  zIndex: 0,
                  borderRadius: '2px'
                }}
              />
              <span style={{ position: 'relative', zIndex: 1 }}>trusted place</span>
            </span>
            {' '}for people at all stages of their health journey to share their experiences and help shape better understanding.
          </p>
        </div>
      </div>
    </section>
  );
};
